<div style = "justify-content: center;" class="modal-header">
	<h4 class="modal-title" id="modal-basic-title">Manual Add</h4>
  </div>
  <div class="modal-body">
	  <div class = "subscriptionMain">
			<!-- <img style="width:250px;" src = "../../assets/Subscrybe.png"> -->
			<ng-container *ngIf = "subscriptionUrl">
			<img style="max-width:250px;max-height:200px;" src="https://logo.clearbit.com/{{subscriptionUrl.replace('netflix','netflixinvestor')}}">
		</ng-container>
			<p class = "subscriptionName">{{subscriptionName}}</p>
	  </div>
	
	<form>
	  <div class="form-group">

			<label for = "subName">Subscription Name</label>
			<input #subName (blur) = "updateName(subName.value)" type="text" class="form-control" id="subName" aria-describedby="emailHelp" value = {{subscriptionName}}>


			<label for = "subUrl">Subscription Url</label>
			<input #subUrl (blur) = "updateUrl(subUrl.value)" type="text" class="form-control" id="subUrl" aria-describedby="emailHelp" value = {{subscriptionUrl}}>
		<label for="endSub">Next Billing Date</label>
		<div class="input-group">
		  <input #endSub id="endSub" class="form-control"  name="dp" ngbDatepicker #dp="ngbDatepicker">
		  <div class="input-group-append">
			<button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
		  </div>
		</div>

		<label for="price">Price</label>
		<input #promptPrice (blur) = "updatePrice(promptPrice.value)" type="text" class="form-control" id="price" aria-describedby="emailHelp" >

		<label for="paymentSched">Payment Schedule</label>
		<select #paymentSched (blur) = "updateSched(paymentSched.value)" style = "width:100%;" class = "form-control">
			<option  value="monthly" [selected]="true">Monthly</option>
			<option  value="weekly" >Weekly</option>
			<option  value="bi-weekly">Bi-Weekly</option>
			<option  value="quarterly">Quarterly</option>
			<option  value="bi-annually">Bi-Annually</option>
			<option  value="annualy">Annually</option>
		</select>


	  </div>
	</form>
  </div>
  <div class="modal-footer">
	<button type="button" (click)="add(endSub.value)" class="btn btn-outline-dark"> Add</button>
  </div>


  <div class = "cred">
		<a href="https://clearbit.com">Logos provided by Clearbit</a>
		</div>